var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c("div", [
        _c("div", { staticClass: "videosWidgetWrap" }, [
          _c(
            "div",
            { staticClass: "videosWidget" },
            _vm._l(_vm.loaded_videos, function(video, index) {
              return _c(
                "div",
                {
                  staticClass: "videoItem",
                  style: {
                    backgroundImage:
                      "url('" +
                      video.cover_image.sizes["videos-cover-image"] +
                      "')",
                    "background-size": "cover",
                    "background-position": "center",
                    "background-repeat": "no-repeat"
                  },
                  on: {
                    click: function($event) {
                      return _vm.openVideo(video.video.link)
                    }
                  }
                },
                [
                  index == 0
                    ? _c("div", { staticClass: "textGroup textGroupLarge" }, [
                        _vm._m(0, true),
                        _vm._v(" "),
                        _c("h3", [_vm._v("Play")]),
                        _vm._v(" "),
                        _c("h3", { staticClass: "boldHeading" }, [
                          _vm._v("Video")
                        ])
                      ])
                    : _c("div", { staticClass: "textGroup" }, [
                        _vm._m(1, true),
                        _vm._v(" "),
                        _c("h3", [_vm._v(_vm._s(video.title))])
                      ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.loaded_videos.length < _vm.all_videos.length
            ? _c(
                "div",
                {
                  staticClass: "videosLoad",
                  on: {
                    click: function($event) {
                      return _vm.update(_vm.page + 1)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "far fa-undo-alt" }),
                  _vm._v("\n            Load more videos\n        ")
                ]
              )
            : _vm._e()
        ])
      ])
    : _c("div", { staticClass: "loader" }, [
        _c("i", { staticClass: "fas fa-circle-notch fa-spin" })
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "playCircle" }, [
      _c("i", { staticClass: "fas fa-play" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "playCircle" }, [
      _c("i", { staticClass: "fas fa-play" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }